<template>
  <div v-if="enableCorners" class="matrix_optionsTable matrix_table">
    <div class="matrix_tableHeader">
      {{ $t("Corners") }}
    </div>
    <div class="sidebar_popup">
      <div class="cornersContainer">
        <div
          v-for="(corner, index) in getCornersh"
          :key="index"
          :class="'corner ' + corner.type"
        >
          <div class="cornerArea">
            <label :class="{ switch: true, isActive: corner.isActive }">
              <input v-model="corner.isActive" type="checkbox" />
              <span class="slider round"></span>
              <span class="active status">{{ $t("AN") }}</span>
              <span class="inactive status">{{ $t("AUS") }}</span>
            </label>
          </div>
          <div class="cornerArea">
            <div
              v-show="corner.subItems[corner.subItemIndex].type != 'line'"
              class="radiusArea"
            >
              <span>{{ $t("R") }}</span>
              <input
                :id="'radius_' + corner.type"
                v-model.number="corner.x"
                type="text"
                @keydown.enter="onEnter"
              />
            </div>
            <div
              v-show="corner.subItems[corner.subItemIndex].type == 'line'"
              class="coordonatesArea"
            >
              <div class="x-container">
                <span>{{ $t("X") }}</span>
                <input
                  :id="'x_' + corner.type"
                  v-model.number="corner.x"
                  type="text"
                  @keydown.enter="onEnter"
                />
              </div>
              <div class="y-container">
                <span>{{ $t("Y") }}</span>
                <input
                  :id="'y_' + corner.type"
                  v-model.number="corner.y"
                  type="text"
                  @keydown.enter="onEnter"
                />
              </div>
            </div>
          </div>
          <div class="cornerArea">
            <div
              v-for="(subItem, cornerIndex) in corner.subItems"
              :key="cornerIndex"
              :class="{
                cornerImg: true,
                isActive: corner.subItemIndex == cornerIndex
              }"
            >
              <img
                :src="subItem.image_url"
                @click="changeActiveItemClick($event, corner.type, cornerIndex)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useImageEditorStore, ["getCorners", "getPOIEVariables"]),
    getCornersh: function () {
      return this.getCorners.corners;
    },
    enableCorners: function () {
      return parseFloat(this.getPOIEVariables.enableCorners);
    }
  },
  methods: {
    ...mapActions(useImageEditorStore, [
      "changeCornerStatus",
      "changeActiveItem"
    ]),
    getShowCornerArea: function (corner) {
      return (
        corner.subItems[corner.subItemIndex].type == "circle" ||
        corner.subItems[corner.subItemIndex].type == "circle2"
      );
    },
    onEnter: function (event) {
      event.preventDefault();
    },
    changeCornerStatus: function (event, corner_code) {
      this.changeCornerStatus(corner_code);
    },
    changeActiveItemClick: function (event, corner_code, index) {
      this.changeActiveItem({
        corner_code: corner_code,
        index: index
      });
    }
  }
};
</script>
